import React from 'react'
import { Grid } from '@material-ui/core'
import PropTypes from 'prop-types'

const FormCol = ({ xs, sm, md, lg, xl, children }) => {
  return (
    <Grid item xs={xs} sm={sm} md={md} lg={lg} xl={xl}>
      {children}
    </Grid>
  )
}

FormCol.defaultProps = {
  xl: 2,
  lg: 2,
  md: 3,
  sm: 4,
  xs: 12,
}

FormCol.propTypes = {
  xl: PropTypes.number,
  lg: PropTypes.number,
  md: PropTypes.number,
  sm: PropTypes.number,
  xs: PropTypes.number,
  children: PropTypes.node.isRequired,
}

export default FormCol
